import React from 'react'
import Header from '../component/Common/Header'
import Banner from '../component/Common/Banner'
import LoginArea from '../component/Login'
import Footer from '../component/Common/Footer'
import { withRouter } from "react-router-dom";
const Login = (props) => {
    return (
        <>
          
            {/* <Banner title="Login" /> */}
            <LoginArea />
           
        </>
    )
}


export default withRouter(Login);